import { UserSchema } from '../definitions/schemas';
import { UserAuth } from '../definitions/userAuth';
import Analytics from './Analytics';
import Messenger from './Messenger';

export const identifyTools = (
  user: UserSchema,
  userAuth: UserAuth | undefined,
  isExtensionInstalled = false
) => {
  /**
   * Tools identity
   */
  Analytics.identify(user, undefined, userAuth);
  Messenger.identify(user, isExtensionInstalled);
};

export const anonymizeTools = () => {
  Analytics.anonymize();
  Messenger.anonymize();
};
